import React from "react";
import { useRecommendationStore } from "../../stores/recommendationStore";
import { PermissionWrapper } from "components";

// Компонент заголовків таблиці рекомендованих цін
const RecommendationTableHeader = ({ headers }) => {
  // Отримуємо дані та дії зі стору рекомендацій
  const sort_by = useRecommendationStore((state) => state.filters.sort_by);
  const sort_asc = useRecommendationStore((state) => state.filters.sort_asc);
  const setSort = useRecommendationStore((state) => state.setSort);

  return (
    <thead>
      <tr>
        {headers.map(({ label, field, requiredPermission, className }) => (
          <PermissionWrapper key={label} requiredPermission={requiredPermission}>
            <th
              className={`${field ? "clickable" : ""} ${className || ""} `} // Додавання класу для вимкнення курсораfield ? "clickable" : ""}
              onClick={field ? () => setSort(field) : undefined}
            >
              {label}
              <span className="sort-icon">
                {field === sort_by && (sort_asc ? " ▲" : " ▼")}
              </span>
            </th>
          </PermissionWrapper>
        ))}
      </tr>
    </thead>
  );
};

export default RecommendationTableHeader;
